import React, {useEffect} from "react";
import './customModal.css';

function CustomModal({modalName, content, keyboard, backdrop, modalClasses, onClose, closeButtonRef}) {
    useEffect(() => {
        if (!onClose) {
            return;
        }
        const modalElement = document.getElementById(modalName);

        const handleModalClose = () => {
            // Perform actions when the modal is closed
            onClose();
        };

        modalElement.addEventListener('hidden.bs.modal', handleModalClose);

        return () => {
            modalElement.removeEventListener('hidden.bs.modal', handleModalClose);
        };
    }, []);
    return (
        <div className="modal fade" id={modalName} data-bs-backdrop={backdrop ?? true}
             data-bs-keyboard={keyboard ?? true} tabIndex="0"
             aria-labelledby={modalName + "Label"}>
            <div
                className={"modal-dialog " + (modalClasses ?? '')}>
                <div className="modal-content">
                    <button style={{display: 'none'}} ref={closeButtonRef} data-bs-dismiss="modal"></button>
                    {content}
                </div>
            </div>
        </div>
    )
}

export default CustomModal;
